class SihaOffers extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.scroller = this.querySelector('[data-siha-offers-scroller]');
    this.pagination = this.querySelector('[data-siha-offers-pagination]');
    this.cards = [...this.querySelectorAll('[data-siha-offer-card]')];
    this.dots = [...this.querySelectorAll('[data-siha-offer-dot]')];
    this.countdowns = [...this.querySelectorAll('[data-siha-countdown]')];

    if (!this.scroller || !this.cards.length) return;

    this.initialized = true;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleDotClick = this.handleDotClick.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.updateActiveCard = this.updateActiveCard.bind(this);

    this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
    this.pagination?.addEventListener('click', this.handleDotClick);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.updateActiveCard);
      this.resizeObserver.observe(this.scroller);
    }

    this.updateCountdowns();
    if (this.countdowns.length) {
      this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 1000);
    }

    requestAnimationFrame(this.updateActiveCard);
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.handleScroll);
    this.pagination?.removeEventListener('click', this.handleDotClick);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.resizeObserver?.disconnect();
    window.cancelAnimationFrame(this.scrollFrame);
    window.clearInterval(this.countdownTimer);
    this.initialized = false;
  }

  handleScroll() {
    window.cancelAnimationFrame(this.scrollFrame);
    this.scrollFrame = window.requestAnimationFrame(this.updateActiveCard);
  }

  handleVisibilityChange() {
    if (!document.hidden) this.updateCountdowns();
  }

  handleDotClick(event) {
    const dot = event.target.closest('[data-siha-offer-dot]');
    if (!dot || !this.pagination.contains(dot)) return;

    this.goToCard(Number(dot.dataset.sihaOfferDot));
  }

  goToCard(index) {
    const card = this.cards[index];
    if (!card) return;

    const target = card.offsetLeft - (this.scroller.clientWidth - card.clientWidth) / 2;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.scroller.scrollTo({
      left: Math.max(target, 0),
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  }

  updateActiveCard() {
    const scrollerBox = this.scroller.getBoundingClientRect();
    const viewportCenter = scrollerBox.left + scrollerBox.width / 2;
    let activeIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    this.cards.forEach((card, index) => {
      const cardBox = card.getBoundingClientRect();
      const cardCenter = cardBox.left + cardBox.width / 2;
      const distance = Math.abs(cardCenter - viewportCenter);

      if (distance < nearestDistance) {
        nearestDistance = distance;
        activeIndex = index;
      }
    });

    this.cards.forEach((card, index) => card.classList.toggle('is-active', index === activeIndex));
    this.dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-pressed', String(isActive));
    });
  }

  updateCountdowns() {
    this.countdowns.forEach((countdown) => this.updateCountdown(countdown));
  }

  updateCountdown(countdown) {
    const endTime = Date.parse(countdown.dataset.endDate || '');

    if (Number.isNaN(endTime)) {
      countdown.hidden = true;
      return;
    }

    const remaining = endTime - Date.now();
    const label = countdown.querySelector('[data-siha-countdown-label]');
    const values = countdown.querySelector('.siha-offer-card__countdown-values');
    countdown.hidden = false;

    if (remaining <= 0) {
      countdown.classList.add('is-expired');
      if (label) label.textContent = countdown.dataset.expiredText || 'Offerta terminata';
      if (values) values.hidden = true;
      return;
    }

    countdown.classList.remove('is-expired');
    if (values) values.hidden = false;

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.setCountdownValue(countdown, '[data-siha-days]', days);
    this.setCountdownValue(countdown, '[data-siha-hours]', hours);
    this.setCountdownValue(countdown, '[data-siha-minutes]', minutes);
    this.setCountdownValue(countdown, '[data-siha-seconds]', seconds);
  }

  setCountdownValue(countdown, selector, value) {
    const element = countdown.querySelector(selector);
    if (element) element.textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('siha-offers')) {
  customElements.define('siha-offers', SihaOffers);
}


